export const leavesAndAttendanceStrings = {
  en: {
    holidayList: 'Holiday List',
    leaveCalendar: 'Leave Calendar',
    year: 'Year',
    day: 'Day',
    toDate: 'To Date',
    days: 'Days',
    leaveStatus: 'Leave Status',
    leaveType: 'Leave Type',
    showHoliday: 'SHOW HOLIDAYS',
    addNewHoliday: 'Add New Holiday',
    editHoliday: 'Edit Holiday',
    selectHolidayTypePlace: 'Select Holiday Type',
    occasion: 'Occasion',
    holidayType: 'Holiday Type',
    addHolidaySuccess: 'Holiday Added Successfully!',
    updateHolidaySuccess: 'Holiday Updated Successfully',
    actions: 'Actions',
    approve: 'Approve',
    reject: 'Reject',
    approveLeaveSuccess: 'Leave Approved Successfully!',
    rejectLeaveSuccess: 'Leave Rejected Successfully!',
    cancelLeaveSuccess: 'Leave Cancelled Successfully!',
    addUnplannedLeave: 'Add Unplanned Leave',
    employeeName: 'Employee Name',
    fromDate: 'From Date',
    session: 'Session',
    session1: 'Session 1',
    session2: 'Session 2',
    reason: 'Reason',
    unplannedLeave: 'Unplanned Leave',
    addLeaveSuccess: 'Leave Added Successfully!',
    selectEmployee: 'Select employee',
    selectSession: 'Select session',
    approvedBy: 'Approved By',
    cancel: 'Cancel',
    updatedBy: 'Updated By'
  },
  es: {}
}
